import { useCallback } from "react";
import { UserService } from "services";
import UserRecommendationList from "./list";

const UserRecommendationNewList = () => {

  const fetch = useCallback((page: number, search: string | undefined) => UserService.userRecommendationsAll({ page: page ?? 0, search: search, crm: false }), []);

  return <UserRecommendationList fetch={fetch} />;
}

export default UserRecommendationNewList;